<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Caroline K Fraser is a Scottish fictional story writer. She reads a lot and enjoys historical fiction stories; other genres she enjoys are science fiction and horror.</p>
<p style="text-align: center;">In her spare time, Caroline likes to play tennis and go hiking.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ce5de244